import { storeToRefs } from 'pinia'
import { useSentry } from '@myfunnow/web-core/sentry'

import { useAuthStore } from '@/store/auth'

import type { EatigoMemberInfoData } from '@/types/api'

export function useSentryRegister() {
  const authStore = useAuthStore()

  const { user, username } = storeToRefs(authStore)

  const sentry = useSentry()

  function setSentryUserData(userData: Nullable<EatigoMemberInfoData>) {
    const data = userData
      ? {
          ...(!!userData?.uid && { id: userData.uid }),
          ...(!!username.value && { username: username.value }),
          ...(!!userData?.email && { email: userData.email }),
        }
      : null

    sentry?.setUser(data)
  }

  watch(user, setSentryUserData, { immediate: true })
}
